// extracted by mini-css-extract-plugin
export default {"container":"Question_container__43+-o","locked":"Question_locked__zjp+W"};